import i18next from 'i18next';
import traverse from 'traverse';

export const translateSchema = (schema) => {
  const types = ['object', 'boolean', 'number'];
  const translated = traverse(schema).forEach(function (item) {
    if (!types.includes(typeof item)) {
      const translated = i18next.t(item);
      this.update(translated);
    }
  });
  return translated;
};

export function translateLiteral (key) {
  return i18next.t(key);
}
